import React from "react";
import { toast } from "sonner";
import { useDispatch } from "react-redux";
import {
  setName,
  setEmail,
  setUserCountry,
  setUserState,
  setUserCity,
  setUserPincode,
  setUserAddress,
} from "../../configs/userSlice";
import { useNavigate } from "react-router-dom";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import {
  USER_PROFILE_UPDATED,
  USER_PROFILE_EMAIL_EXISTS_ERROR,
} from "../../constants/text_constants";
import userLogout from "../../utils/userLogout";
import saveAuthToken from "../../utils/saveAuthToken";

function isGmail(email) {
  const gmailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
  return gmailRegex.test(email);
}

const checkIfFormIsFull = (
  userName,
  userEmail,
  userAddress,
  country,
  city,
  state,
  pincode,
  userMobile
) => {
  if (userName === "") {
    toast("Enter your name");
    return false;
  }
  if (userEmail === "") {
    toast("Enter your email");
    return false;
  }
  if (!isGmail(userEmail)) {
    toast("Enter your gmail id");
    return false;
  }
  if (userAddress === "") {
    toast("Enter your address");
    return false;
  }
  if (!country) {
    toast("Select Country");
    return false;
  }
  if (!state) {
    toast("Select State");
    return false;
  }
  if (!city) {
    toast("Select City");
    return false;
  }
  if (pincode === "") {
    toast("Enter your pincode");
    return false;
  }
  if (userMobile === "") {
    toast("Enter your phone number");
    return false;
  }

  return true; // ✅ all good
};

const submitUserDetails = async (userData, navigate, dispatch, retries = 6) => {
  try {
    const formData = new FormData();
    formData.append("name", userData?.userName);
    formData.append("mobile", userData?.userMobile);
    formData.append("address", userData?.userAddress);
    formData.append("zipcode", userData?.pincode);
    formData.append("email", userData?.userEmail);
    formData.append("country_id", userData?.country?.id);
    formData.append("state_id", userData?.state?.id);
    formData.append("city_id", userData?.city?.id);
    const authToken = sessionStorage.getItem("token");

    const requestOptions = {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: formData,
    };

    const response = await fetch(
      process.env.REACT_APP_RANK_PLUS_EDIT_PROFILE,
      requestOptions
    );
    if (!response.ok) {
      if (response.status >= 400 && response.status < 500) {
        userLogout(navigate, dispatch, true);
      }
      if (response.status >= 500 && response.status < 600 && retries > 0) {
        console.warn(`Retrying... attempts left: ${retries}`);
        setTimeout(() => submitUserDetails(userData, navigate, dispatch, retries - 1), 10000);
        return;
      } else {
        throw new Error(`HTTP error: ${response.status}`);
      }
    }
    const json = await response.json();

    if (json?.data?.error === USER_PROFILE_EMAIL_EXISTS_ERROR) {
      toast(json?.data?.error);
    }

    if (json?.message === USER_PROFILE_UPDATED) {
      userData.referralCode = json?.data?.referral_code || "";
      sessionStorage.setItem("userDetail", JSON.stringify(userData));
      saveAuthToken(json?.data?.token);
      navigate(UNPROTECTED_ROUTES?.home);
      toast("Profile Updated Successfully ✅");
    }
  } catch (err) {
    console.error("Error submitUserDetails", err);
  }
};

const SubmitButton = ({
  userName,
  userEmail,
  userMobile,
  userAddress,
  country,
  state,
  city,
  pincode,
  btnText,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

function handleClick() {
  const isValid = checkIfFormIsFull(
    userName,
    userEmail,
    userAddress,
    country,
    city,
    state,
    pincode,
    userMobile
  );

  if (!isValid) return;

  // ✅ Only runs if valid
  dispatch(setName(userName));
  dispatch(setEmail(userEmail));
  dispatch(setUserCountry(country?.name));
  dispatch(setUserState(state?.name));
  dispatch(setUserCity(city?.name));
  dispatch(setUserAddress(userAddress));
  dispatch(setUserPincode(pincode));

  const userData = {
    userName,
    userEmail,
    userAddress,
    country,
    state,
    city,
    pincode,
    userMobile
  };

  submitUserDetails(userData, navigate, dispatch);
}
 return (
  <div className="flex justify-center my-7 px-4">
    <button
      className="w-full max-w-[20rem] px-5 py-3 text-base font-bold text-white 
                 bg-gradient-to-r from-cyan-400 to-purple-600 
                 rounded-full shadow-lg 
                 hover:-translate-y-1 hover:shadow-2xl transition-all"
      onClick={()=>handleClick()}
    >
      <span className="drop-shadow-md">{btnText}</span>
    </button>
  </div>
);

};

export default SubmitButton;
